/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { App } from 'vue'
import DeliveryDetailsFooter from '@/modules/address-validation/components/delivery-details-footer/delivery-details-footer.vue'
export default function setupComponent(app: App<Element>): void {
  app.component('FeDeliveryDetailsFooter', DeliveryDetailsFooter)
}
